import get from 'lodash-es/get'
import handleAuthError from './authMiddleware'
import {
  deleteBookmarkRequest,
  createBookmarkRequest,
  getBookmarksForItemsRequest
} from '../../utils/user'
import { showAlert } from '../common'
import { logError } from '../../utils/errors'
import {
  reportItemAddedToFavourite,
  reportItemRemovedFromFavourite,
  reportItemAddedToCollection,
  reportItemRemovedFromCollection
} from '../../analytics/userAnalytics'

const deleteBookmarkRequestAction = (collectionID, itemID) => ({
  type: 'deleteBookmarkRequest',
  payload: { collectionID, itemID }
})
const deleteBookmarkSuccessAction = (
  collectionID,
  itemID,
  isFavouriteCollection
) => {
  if (isFavouriteCollection) {
    reportItemRemovedFromFavourite(itemID)
  } else {
    reportItemRemovedFromCollection(itemID)
  }

  return {
    type: 'deleteBookmarkSuccess',
    payload: { collectionID, itemID }
  }
}
const deleteBookmarkFailureAction = (collectionID, itemID) => ({
  type: 'deleteBookmarkFailure',
  payload: { collectionID, itemID }
})

export const deleteBookmark = (
  collectionID,
  itemID,
  bookmarkID,
  isFavouriteCollection
) => {
  return async (dispatch, getState) => {
    const {
      user: { token }
    } = getState()
    if (!token)
      return dispatch(deleteBookmarkFailureAction(collectionID, itemID))

    dispatch(deleteBookmarkRequestAction(collectionID, itemID))

    try {
      await deleteBookmarkRequest(token, bookmarkID)
      return dispatch(
        deleteBookmarkSuccessAction(collectionID, itemID, isFavouriteCollection)
      )
    } catch (err) {
      if (get(err, 'response.status') === 401) {
        return dispatch(
          handleAuthError(deleteBookmark(collectionID, itemID, bookmarkID))
        )
      } else {
        logError(err)
        const message =
          "Unfortunately we couldn't delete the bookmark. Please try again."
        dispatch(showAlert(message, 'failure', false))
        return dispatch(deleteBookmarkFailureAction(collectionID, itemID))
      }
    }
  }
}

const addBookmarkRequestAction = (collectionID, itemID) => ({
  type: 'addBookmarkRequest',
  payload: { collectionID, itemID }
})
const addBookmarkSuccessAction = (
  bookmarkID,
  collectionID,
  itemID,
  isFavouriteCollection
) => {
  if (isFavouriteCollection) {
    reportItemAddedToFavourite(itemID)
  } else {
    reportItemAddedToCollection(itemID)
  }

  return {
    type: 'addBookmarkSuccess',
    payload: { bookmarkID, collectionID, itemID }
  }
}
const addBookmarkFailureAction = (collectionID, itemID) => ({
  type: 'addBookmarkFailure',
  payload: { collectionID, itemID }
})

export const addBookmark = (collectionID, itemID, isFavouriteCollection) => {
  return async (dispatch, getState) => {
    const {
      user: { token }
    } = getState()
    if (!token) return dispatch(addBookmarkFailureAction(collectionID, itemID))

    dispatch(addBookmarkRequestAction(collectionID, itemID))

    try {
      const { bookmark_id } = await createBookmarkRequest(
        token,
        collectionID,
        itemID
      )
      return dispatch(
        addBookmarkSuccessAction(
          bookmark_id,
          collectionID,
          itemID,
          isFavouriteCollection
        )
      )
    } catch (err) {
      if (get(err, 'response.status') === 401) {
        return dispatch(handleAuthError(addBookmark(collectionID, itemID)))
      } else {
        logError(err)
        const message =
          "Unfortunately your bookmark hasn't been added. Please try again."
        dispatch(showAlert(message, 'failure', false))
        return dispatch(addBookmarkFailureAction(collectionID, itemID))
      }
    }
  }
}

const getBookmarksForItemsRequestAction = itemIds => ({
  type: 'getBookmarksForItemsRequest',
  payload: { itemIds }
})
const getBookmarksForItemsSuccessAction = bookmarks => {
  return {
    type: 'getBookmarksForItemsSuccess',
    payload: { bookmarks }
  }
}
const getBookmarksForItemsFailureAction = itemIds => ({
  type: 'getBookmarksForItemsFailure',
  payload: { itemIds }
})

const deferBookmarksToLoad = itemIds => ({
  type: 'deferBookmarksToLoad',
  payload: { itemIds }
})

const resetBookmarksToLoad = () => ({
  type: 'resetBookmarksToLoad'
})

export const getBookmarksForItems = itemIds => {
  return async (dispatch, getState) => {
    const {
      user: { token, isSignedIn, bookmarksToLoad }
    } = getState()

    if (!itemIds && !bookmarksToLoad) {
      return {
        type: 'nullAction'
      }
    }

    if (!token || !isSignedIn) {
      // Items have been loaded, but user has not signed in yet, put item into defer load list
      dispatch(deferBookmarksToLoad(itemIds))
      return {
        type: 'nullAction'
      }
    }

    itemIds = itemIds || bookmarksToLoad

    dispatch(getBookmarksForItemsRequestAction(itemIds))

    try {
      const { bookmarks } = await getBookmarksForItemsRequest(token, itemIds)
      await dispatch(getBookmarksForItemsSuccessAction(bookmarks))
      return dispatch(resetBookmarksToLoad())
    } catch (err) {
      if (get(err, 'response.status') === 401) {
        return dispatch(handleAuthError(getBookmarksForItems(itemIds)))
      } else {
        logError(err)
        return dispatch(getBookmarksForItemsFailureAction(itemIds))
      }
    }
  }
}
